import { useLang } from "../i18n";

export default function EditorialMarquee({ variant = "default" }) {
  const { t } = useLang();
  const items = t.marquee;
  const row = [...items, ...items, ...items];

  return (
    <div
      data-testid={`editorial-marquee-${variant}`}
      className={`overflow-hidden border-y border-white/10 py-6 ${
        variant === "alt" ? "bg-primary/10" : "bg-[#051838]"
      }`}
    >
      <div className="marquee-track flex items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-2xl italic tracking-tight text-white/70 md:text-3xl">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-primary" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
